<span class="flex-center full-height">
  <mat-icon *ngIf="canShowIcon()" [svgIcon]="getIconName()"></mat-icon>
</span>
